import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faCheckCircle, faUserSlash, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { actions as actionSite } from './../../../redux/actions/site';
import './Listagem.scss';

import service from '../../../services/usuarios';

const Listagem = props => {

    const history = useHistory();
    const dispatch = useDispatch();

    const [selecionados, setSelecionados] = useState([]);

    const [page, setPage] = useState(0);
    const paramsSearch = "";
    const total = props.registros.total;

    const setAcao = (acao, id) => {
        let rota = `/painel/${props.rota}/${acao}`;
        if (id) {
            rota += `/${id}`;
        }
        history.push(rota);
    };

    // const recusar = async (obj) => {
    //     if (window.confirm("Deseja mesmo recusar a revendedora?")) {
    //         const body = { recusado: true, dataRecusa: Date.now() }
    //         await props.service.upsert(body, obj._id);
    //         props.service.getList(paramsSearch, page);
    //     }
    // }

    const openModalRecusarUm = (id) => {
        
        
        const configModal = {
            msg:`Escolha uma ação para a recusa desse cadastro`, title: "Recusar Cadastro",
            actions: [
                { label: "Recusar com e-mail", class: "azul", callback: recusar, arg: [id, true] },
                { label: "Apenas recusar", class: "cinza", callback: recusar, arg:[id] },
                //{ label: "Fechar", class: "vermelho", action: "closeModal" },
            ]
        }

        dispatch(actionSite.setModal(configModal))
    }

    const recusar = async(params) => {
        const [id,enviarEmail] = params;
        
        dispatch(actionSite.setModal(null));
        dispatch(actionSite.setLoadingMsg("Recusando cadastro..."))
        const body = { id, enviarEmail };
        const res = await service.recusarCadastro(body);
        dispatch(actionSite.setLoadingMsg(res.msg));
        
        setTimeout(() => {
            dispatch(actionSite.setLoadingMsg(""));
            if(!res.erro){
                props.service.getList([], 0);
            }    
        }, 2000);
    }

    const toogleRow = row => {
        if(row.status === 2){

            const _selecionados = [...selecionados];
            const id = row._id;
            if (_selecionados.includes(id)) {
                const index = _selecionados.indexOf(id);
                _selecionados.splice(index, 1);
            } else {
                _selecionados.push(id);
            }
            
            setSelecionados(_selecionados);
        }
    }

    const renderItems = () => {
        if (props.loadingList) {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Carregando listagem...</td>
                </tr>
            );
        }
        if (props.registros.rows.length > 0) {
            return props.registros.rows.map((ele, index) => {
                return (
                    <tr key={index} id={ele._id} onClick={() => toogleRow(ele)}>
                        <td className="check">
                            {ele.status === 2 && selecionados.includes(ele._id) && <FontAwesomeIcon icon={faCheckCircle} />}
                            {ele.status === 2 && !selecionados.includes(ele._id) && <FontAwesomeIcon icon={faCircle} />}

                        </td>
                        {renderColumnsItems(ele)}
                        <td className="acoes">
                            {ele.status === 2 &&
                                <>
                                    <button className="edit" onClick={(e) => { e.stopPropagation(); setAcao('processar', ele._id) }}>
                                        <FontAwesomeIcon icon={faUserCheck} /></button>

                                    <button className="delete" onClick={(e) => { e.stopPropagation(); openModalRecusarUm(ele._id) }}>
                                        <FontAwesomeIcon icon={faUserSlash} /></button>
                                </>
                            }
                        </td>
                    </tr>
                )
            })
        } else {
            return (
                <tr>
                    <td colSpan={props.config.columns.length + 2}>Nenhum registro encontrado</td>
                </tr>
            )
        }
    };

    const renderTitles = () => {
        const thead = (
            <tr>
                <td>#</td>
                {renderColumns()}
                <td width="150">Ações</td>
            </tr>
        );
        return thead;
    }

    const renderColumns = () => {
        return props.config.columns.map((c, i) => {
            return (
                <td key={i}>{c.label}</td>
            );
        });
    }

    const converts = {
        toImg: s => {
            return <img src={s} className="imgCrud" alt="imagem" />
        },
        toSimNao: s => {
            return s ? "Sim" : "Não";
        },
        statusCad: n => {
            switch (n) {
                case 0:
                    return "Conta não ativada";
                case 1:
                    return "Conta incomleta";
                case 2:
                    return "Ok para processar"
                default:
                    return '';
            }
        }
    }

    const renderColumnsItems = (row) => {
        return props.config.columns.map((c, i) => {
            const cls = c.field === "ordem" ? 'order' : '';
            return (
                <React.Fragment key={i}>
                    <td className={cls} width={c.width || ""}>
                        {c.convert && typeof c.convert === 'string' && converts[c.convert](row[c.field])}
                        {c.convert && typeof c.convert === 'function' && c.convert(row[c.field])}
                        {!c.convert && row[c.field]}
                    </td>
                </React.Fragment>
            );
        });
    }

    const proximo = () => {
        const skip = page + props.config.pagination.limit;
        if (skip < total) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const temProximo = () => {
        const skip = page + props.config.pagination.limit;
        return skip < total;
    }
    const temAnterior = () => {
        const skip = page - props.config.pagination.limit;
        return skip >= 0;
    }

    const anterior = () => {
        const skip = page - props.config.pagination.limit;
        if (skip >= 0) {
            props.service.getList(paramsSearch, skip);
            setPage(skip)
        }
    }

    const getNumeroUltimoItem = () => {
        let n = ((page) + props.config.pagination.limit);
        if (n > total) {
            n = total;
        }
        return n;
    }

    const openModalRecusarVarios = () => {
        
        const configModal = {
            msg:`Escolha uma ação para a recusa em lote`, title: "Recusar Cadastros",
            actions: [
                { label: "Recusar com e-mail", class: "azul", callback: recusarVarios, arg:true },
                { label: "Apenas recusar", class: "cinza", callback: recusarVarios },
                //{ label: "Fechar", class: "vermelho", action: "closeModal" },
            ]
        }

        dispatch(actionSite.setModal(configModal))
    }

    const recusarVarios = async(enviarEmail=false) => {
        
        
        dispatch(actionSite.setModal(null));
        dispatch(actionSite.setLoadingMsg("Recusando cadastros..."))
        const body = { ids:selecionados, enviarEmail };
        const res = await service.recusarVariosCadastro(body);
        dispatch(actionSite.setLoadingMsg(res.msg));
        
        setTimeout(() => {
            dispatch(actionSite.setLoadingMsg(""));
            if(!res.erro){
                props.service.getList([], 0);
            }    
        }, 2000);
    }

    return (
        <>
            <div className="crudView">
                <div className="form">
                    <button type="button" disabled={selecionados.length === 0} className={selecionados.length === 0 ? "disabled" : ""}
                        onClick={() => openModalRecusarVarios()}><FontAwesomeIcon icon={faBan} /> Recusar selecionados</button>
                </div>
                <div className="gridView">
                    <div className="pagination">
                        <span>{page + 1}-{getNumeroUltimoItem()} de {props.registros.total}</span>
                        <div className="links">
                            <span onClick={() => anterior()} className={!temAnterior() ? "disable" : ""}>anterior</span>
                            <span onClick={() => proximo()} className={!temProximo() ? "disable" : ""}>próximo</span>
                        </div>
                    </div>
                    <table cellPadding="0" cellSpacing="0">
                        <thead>
                            {renderTitles()}
                        </thead>
                        <tbody>
                            {renderItems()}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default Listagem;